<template>
  <div class="se-tablecell" :style="[{backgroundImage: this.backgroundImg}, {backgroundColor: this.bgColor}]">
    <!-- <div class="se-tablecell__column-header">
      {{columnHeader}}
    </div> -->
    <div class="se-tablecell__img-overlay" v-if="hasBgImg"></div>
    <div class="se-tablecell__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableCell',
  props: {
    double: {
      type: Boolean
    },
    bgc: {
      type: String
    },
    bgimg: {
      type: String
    }
  },
  data () {
    return {
      data: this.$parent.$parent.$props
    }
  },
  computed: {
    hasBgImg () {
      if (this.bgimg !== undefined) {
        return true
      } else {
        return false
      }
    },
    backgroundImg () {
      return this.hasBgImg ? 'url(' + this.bgimg + ')' : 'none'
    },
    hasBgc () {
      if (this.bgc !== undefined) {
        return true
      } else {
        return false
      }
    },
    bgColor () {
      return this.hasBgc ? this.bgc : '#ffffff'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/vars';
.se-tablecell.img > .se-tablecell__content {
  padding: 0px;
  max-height: 360px;
  @media (min-width: 768px) {
    max-height: 100%;
  }
}
.se-tablecell {
  width: 100%;
  // background: $white;
  position: relative;
  overflow: hidden;
  border: 1px solid $table-border;
  background-color: $white;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  @media (min-width: 768px) {
    width: 50%;
  }
  &.no-overlay {
    min-height: 270px;
    @media (min-width: 768px) {
      min-height: auto;
      &.min-300 {
        min-height: 300px;
      }
    }
    .se-tablecell__img-overlay {
      display: none;
    }
  }
  &.minheight {
    min-height: 280px;
    @media (min-width: 768px) {
      min-height: auto;
    }
  }
  &.img-row {
    min-height: 280px;
  }
  &.contain-img {
    background-size: contain;
  }
  &__column-header {
    background: #fafafa;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    height: 37px;
    width: 100%;
    border: 0.5px solid $table-border;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  &__content {
    // padding-top: 40px;
    // padding-bottom: 40px;
    // padding-left: 20px;
    // padding-right: 20px;
    padding: 8%;
    // margin-top: 37px;
    width: 100%;
    height: 100%;
    // height: calc(100% - 37px);
    // border: 0.5px solid $table-border;
    z-index: 2;
    position: relative;
    @media (min-width: 768px) {
      height: 100%;
      margin-top: 0;
      padding: 12%
    }
    h3:last-child {
      margin-bottom: 0;
    }
    h3,
    .t-h3,
    .t-h3 a {
      margin-bottom: 15px;
      color: $green-light;
      @media (min-width: 768px) {
        margin-bottom: 30px;
      }
      &.t-white {
        color: white;
      }
    }
    .t-chartbody {
      font-weight: 300;
      font-size: 16px;
      line-height: 23px;
      a {
        color: $grey;
      }
      .t-white a {
        color: white;
      }
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: -2;
    }
    p {
      font-family: $font-primary;
      font-size: 16px;
      font-weight: 300;
      line-height: 23px;
      letter-spacing: 0.04em;
      &.t-chartbody {
        font-weight: 300;
      }
      &:last-of-type {
        margin-bottom: 0;
      }
      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 23px;
      }
    }
    ul {
      &.t-ul--light {
        li {
          font-weight: 300;
        }
      }
    }
    .icon {
      width: 80px;
      height: 80px;
      // margin-bottom: 20px;
    }
  }
  &__img-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TableCell.vue